export default __webpack_public_path__ + "static/media/GF_KRUSH_Horizontal.01a4a9c2.jpg";